import {
	Box,
	Divider,
	Grid,
	Hidden,
	IconButton,
	Menu,
	makeStyles
} from '@material-ui/core';
import { ExitToApp } from '@material-ui/icons';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { TranslationPrefixes } from 'consts/translationPrefixes';
import { CurrencyContext } from 'context/currency';
import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps, useHistory, withRouter } from 'react-router-dom';
import i18n from '../../i18n';
import { Currency } from '../../interfaces/currency';
import { Languages } from '../../interfaces/language';
import firebase from '../firebase';
import SideMenu from './SideMenu';

const useStyles = makeStyles((theme) => ({
	icon: {
		minWidth: 30,
	},
	text: {
		whiteSpace: 'nowrap',
	},
	full: {
		width: '100%',
		borderRadius: theme.shape.borderRadius,
		transition: 'background-color 0.3s ease',
		'&:hover': {
			backgroundColor: theme.palette.action.hover,
		},
	},
	flag: {
		marginLeft: 10,
		width: 15,
		height: 15,
	},
	flagWithShadow: {
		marginLeft: 10,
		boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.5)"
	},
	selectorLanguages: {
		display: "flex",
		alignItems: "center"
	},

}));

function AccountMenu(props: RouteComponentProps): JSX.Element {
	const classes = useStyles();
	const history = useHistory();
	const { t } = useTranslation();
	const currencyContext = useContext(CurrencyContext);
	const { accountMenu } = TranslationPrefixes;

	const [lang, setLang] = useState(i18n.language);
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const [anchorSideEl, setAnchorSideEl] = useState<null | HTMLElement>(null);
	const [euroExchangeRate, setEuroExchangeRate] = useState(0.93);

	useEffect(() => {
		const fetchExchangeRates = async () => {
			const response = await fetch('https://api.exchangerate-api.com/v4/latest/USD');
			const data = await response.json();
			if (data.rates.EUR) {
				setEuroExchangeRate(data.rates.EUR)
			}
		}

		fetchExchangeRates();

	}, []);

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleSideClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorSideEl(event.currentTarget);
	};

	const handleSideClose = () => {
		setAnchorSideEl(null);
	};

	const logout = async () => {
		await firebase.logout();
		props.history.replace('/');
	};

	const openCredentialsForm = () => {
		setAnchorEl(null);
		history.push('/credentialsForm');
	};

	const handleLanguageChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		const newLang = event.target.value as Languages;
		i18n.changeLanguage(newLang);
		setLang(newLang);
	};

	const handleCurrencyChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		const newCurrency = event.target.value as Currency;
		currencyContext?.setCurrency({
			value: newCurrency,
			rate: newCurrency === Currency.EURO ? euroExchangeRate : 1
		});
	};

	return (
		<Box paddingX="12px">
			<Divider
			></Divider>


			<Grid style={{ minWidth: "300px", marginBottom: "10px", marginTop: "10px" }} container justifyContent="center" alignItems="center" spacing={1}>

				{/* <Grid item xs={4}>
					
					<Select
						className={classes.selectorLanguages}
						variant="outlined"
						value={lang}
						onChange={handleLanguageChange}
						disableUnderline
						displayEmpty
						fullWidth
					>
						<MenuItem value={Languages.BG}>{Languages.BG}
							<img className={classes.flag} src={bgIcon} alt="bg-flag" />
						</MenuItem>
						<MenuItem value={Languages.EN}>{Languages.EN}
							<img className={classes.flag} src={usIcon} alt="bg-flag" />
						</MenuItem>
					</Select>
				</Grid> */}
				{/* {currencyContext && (
					<Grid item xs={4}  >
						<FormControl fullWidth>
							<Select
								variant="outlined"
								value={currencyContext.currency.value}
								onChange={handleCurrencyChange}

								disableUnderline
								displayEmpty
							>
								<MenuItem value={Currency.USD}>{Currency.USD}</MenuItem>
								<MenuItem value={Currency.EURO}>{Currency.EURO}</MenuItem>
							</Select>
						</FormControl>
					</Grid>
				)} */}
				{/* TO DO: FLAG */}
				{/* <Grid item xs={2}>
					<Box sx={{
						width: 50, // Set the width in pixels
						height: 50, // Set the height in pixels
						display: "flex", // Optional: for centering children
						alignItems: "center", // Optional: center items vertically
						justifyContent: "center", // Optional: center items horizontally
					}}>
						<img style={{ width: "auto", height: 15, }} className={classes.flagWithShadow} src={bgIcon} alt="bg-flag" />
					</Box>
				</Grid> */}
				<Grid item xs={10}  >
				</Grid>
				<Grid item xs={2}  >
					<IconButton onClick={logout}><ExitToApp /></IconButton>
				</Grid>
				<Hidden mdUp>
					<Grid item xs={10} />
					<Grid item xs={2}>

						<IconButton
							aria-label="more"
							aria-controls="long-menu"
							aria-haspopup="true"
							onClick={handleSideClick}
							disableRipple
						>
							<MoreVertIcon />
						</IconButton>
						<Menu
							id="long-menu"
							anchorEl={anchorSideEl}
							keepMounted
							open={Boolean(anchorSideEl)}
							onClose={handleSideClose}
						>
							<SideMenu />
						</Menu>
					</Grid>
				</Hidden>
			</Grid>
		</Box>
	);
}

export default withRouter(AccountMenu);
